import Navbar from "../components/Navbar";
import Trame from "../assets/img/TrameFine.webp";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import Footer from "../components/Footer";
import { useState } from "react";
import { Helmet } from "react-helmet-async";

const faqData = [
  {
    question:
      "Quels types de prestations proposez-vous en peinture intérieure ?",
    answer:
      "Je propose des services de peinture intérieure, incluant la préparation des surfaces, l'application de peinture et les finitions.",
  },
  {
    question:
      "Intervenez-vous uniquement sur des chantiers de rénovation ou aussi sur des projets neufs ?",
    answer:
      "J'interviens aussi bien sur des projets de rénovation que sur des chantiers neufs.",
  },
  {
    question: "Quels types de peinture utilisez-vous ?",
    answer:
      "J’utilise principalement des peintures acryliques pour les murs et les plafonds, ainsi que des peintures adaptées à chaque support. Lorsque certains murs présentent déjà des traces d’humidité ou de moisissure, j’utilise d’abord des produits spécifiques pour traiter le support avant d’appliquer la peinture. J'utilise également des peintures glycéro pour les boiseries, les portes et les supports qui demandent une finition plus résistante.",
  },
  {
    question: "Comment se passe un devis ? Est-ce gratuit ?",
    answer:
      "Je propose des devis gratuits et sans engagement. Il vous suffit de me contacter pour discuter de votre projet, et je vous fournirai un devis détaillé.",
  },
  {
    question: "Faut-il vider la pièce avant votre intervention ?",
    answer:
      "Il est préférable de vider la pièce autant que possible pour faciliter mon travail. Toutefois, je peux également intervenir avec des meubles en place si nécessaire.",
  },
  {
    question: "Combien de temps prend un chantier de peinture intérieure ?",
    answer:
      "La durée d’un chantier de peinture intérieure dépend de la taille du projet et des travaux à réaliser. En général, je m’efforce de terminer les chantiers dans les meilleurs délais tout en garantissant un résultat de qualité.",
  },
  {
    question: "Travaillez-vous seule ou en équipe ?",
    answer:
      "Je travaille principalement seule afin de garantir un travail soigné et un suivi complet du chantier. Toutefois, je peux faire appel à des renforts de confiance lorsque le projet le nécessite, notamment pour les chantiers de plus grande envergure.",
  },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  return (
    <div className="faq">
      <Helmet>
        <title>FAQ – Peinture & décoration à Vannes | Clara Décor</title>
        <meta
          name="description"
          content="Questions fréquentes sur nos prestations à Vannes : délais, produits (peintures & enduits), garanties, ravalement et zone d’intervention dans le Morbihan."
        />
        <link rel="canonical" href="https://claradecor.fr/faq" />
        <meta
          property="og:title"
          content="FAQ – Clara Décor, peinture et décoration à Vannes"
        />
        <meta
          property="og:description"
          content="Délai des travaux, produits sélectionnés, garanties et entretien : retrouvez des réponses précises pour vos projets."
        />
        <meta property="og:url" content="https://claradecor.fr/faq" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://claradecor.fr/images/og-faq.jpg"
        />
        <meta property="og:locale" content="fr_FR" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">
          {`
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Quels types de travaux propose Clara Décor ?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Clara Décor réalise des travaux de peinture intérieure et extérieure, ravalement de façade, enduits décoratifs et revêtements muraux et sols."
          }
        },
        {
          "@type": "Question",
          "name": "Quelle zone d’intervention ?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Clara Décor intervient à Vannes et dans tout le Morbihan pour tous ses projets."
          }
        },
        {
          "@type": "Question",
          "name": "Quels délais et accompagnement ?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Chaque projet est accompagné de l’étude initiale jusqu’aux finitions, avec des délais adaptés à l’ampleur du chantier."
          }
        }
      ]
    }
    `}
        </script>
      </Helmet>

      <Navbar />
      <header>
        <div className="header-left">
          <h1>Des questions ?</h1>
          <p>
            Retrouvez ici
            <span className="color1"> les informations essentielles</span> pour
            mieux comprendre mon accompagnement et mes prestations. Pour toute
            demande spécifique, je reste à
            <span className="color1"> votre écoute.</span>
          </p>
          <div className="header-btn">
            <button
              className="btn-primary"
              onClick={() => {
                const el = document.getElementById("faq-body");
                if (el) {
                  el.scrollIntoView({ behavior: "smooth" });
                }
              }}
              type="button"
            >
              Voir les questions{" "}
              <span className="arrow">
                <FaArrowRight />
              </span>
            </button>
          </div>
        </div>
      </header>
      <body>
        <img src={Trame} className="trame" alt="image de trame Clara Décors" />
        <div className="faq-body" id="faq-body">
          <h2>Foires aux questions</h2>

          {faqData.map((item, index) => (
            <div key={index} className="faq-item">
              <button className="faq-question" onClick={() => toggleFAQ(index)}>
                {item.question}
                <span className="arrow">{openIndex === index ? "▲" : "▼"}</span>
              </button>
              <div
                className={`faq-answer ${openIndex === index ? "open" : ""}`}
              >
                {item.answer}
              </div>
            </div>
          ))}
        </div>

        <div className="suggestions">
          <h2>D'autres questions ?</h2>
          <p className="suggestions-text">
            Chaque projet est unique et il est normal d'avoir des{" "}
            <span className="color1">interrogations spécifiques.</span> Si vous
            ne trouvez pas réponse à vos questions, n'hésitez pas à me contacter
            via le formulaire dédié, je vous répondrais dans les plus brefs
            délais, avec toute l'attention que mérite{" "}
            <span className="color1">votre projet.</span>
          </p>
          <Link to={"/contact"} className="btn-secondary">
            Prendre contact
          </Link>
        </div>
        <div className="prefooter"></div>
      </body>
      <Footer />
    </div>
  );
}
